// extracted by mini-css-extract-plugin
export default {"color":"MicroColorCircle_color__kTDfD","png":"MicroColorCircle_png__Dufrh","selected":"MicroColorCircle_selected__Su4Gz","notSelected":"MicroColorCircle_notSelected__fTOte"};